<section class="normatividad-section">
  <div class="normatividad-box">
    <h2 class="normatividad-title">NORMATIVIDAD.</h2>

    <!-- Tabs -->
    <ul class="nav nav-tabs custom-tabs" id="normaTab" role="tablist">
      <li class="nav-item" role="presentation">
        <button class="nav-link active" id="leyes-tab" data-bs-toggle="tab" data-bs-target="#leyes" type="button" role="tab">
          LEYES
        </button>
      </li>
      <li class="nav-item" role="presentation">
        <button class="nav-link" id="reglamento-tab" data-bs-toggle="tab" data-bs-target="#reglamento" type="button" role="tab">
          REGLAMENTACIÓN
        </button>
      </li>
      <li class="nav-item" role="presentation">
        <button class="nav-link" id="imss-tab" data-bs-toggle="tab" data-bs-target="#imss" type="button" role="tab">
          IMSS
        </button>
      </li>
      <li class="nav-item" role="presentation">
        <button class="nav-link" id="tecnm-tab" data-bs-toggle="tab" data-bs-target="#tecnm" type="button" role="tab">
          TECNM CAMPUS ESCÁRCEGA
        </button>
      </li>
    </ul>

    <!-- Contenido -->
    <div class="tab-content custom-tab-content">

      <!-- LEYES -->
      <div class="tab-pane fade show active" id="leyes" role="tabpanel">
        <h5>LEYES</h5>
        <ul class="pdf-list">
          <li><a href="http://www.diputados.gob.mx/LeyesBiblio/pdf/1_150917.pdf" target="_blank" download>1.- CONSTITUCIÓN POLÍTICA DE LOS ESTADOS UNIDOS MEXICANOS.</a></li>
          <li><a href="http://www.contraloria.campeche.gob.mx/images/documentos/leyes/Constitucion_Politica_del_Estado_de_Camp.pdf" target="_blank" download>2.- CONSTITUCIÓN POLÍTICA DEL ESTADO DE CAMPECHE.</a></li>
          <li><a href="https://www.ordenjuridico.gob.mx/Documentos/Estatal/Campeche/wo20355.pdf" target="_blank" download>3.- LEY DE LOS TRABAJADORES AL SERVICIO DEL ESTADO DE CAMPECHE.</a></li>
          <li><a href="https://www.plataformadetransparencia.org.mx/server/404" target="_blank" download>4.- LEY DE TRANSPARENCIA.</a></li>
          <li><a href="http://www.diputados.gob.mx/LeyesBiblio/pdf/125_120615.pdf" target="_blank" download>5.- LEY FEDERAL DEL TRABAJO.</a></li>
        </ul>
      </div>

      <!-- REGLAMENTACIÓN -->
      <div class="tab-pane fade" id="reglamento" role="tabpanel">
        <h5>REGLAMENTACIÓN</h5>
        <ul class="pdf-list">
          <li><a href="assets/normatividad/reglamentos/1-REGLAMENTO-ESTUDIANTIL.pdf" target="_blank" download>1.-  REGLAMENTO ESTUDIANTIL</a></li>
          <li><a href="assets/normatividad/reglamentos/2-REGLAMENTO-DEL-LAB_REDES.pdf" target="_blank" download>2.- REGLAMENTO DEL LABORATORIO DE REDES.</a></li>
          <li><a href="assets/normatividad/reglamentos/3-REGLAMENTO-DEL-CI.pdf" target="_blank" download>3.- REGLAMENTO DEL CENTRO DE INFORMACIÓN.</a></li>
          <li><a href="assets/normatividad/reglamentos/4-REGLAMENTO-DEL-CC.pdf" target="_blank" download>4.- REGLAMENTO DEL CENTRO DE COMPUTO.</a></li>
          <li><a href="assets/normatividad/reglamentos/5-LABORATORIO-DE-IDIOMAS.pdf" target="_blank" download>5.- REGLAMENTO DEL CENTRO DE IDIOMAS.</a></li>
          <li><a href="assets/normatividad/reglamentos/6-LABORATORIO-DE-GASTR.pdf" target="_blank" download>6.- REGLAMENTO DEL LABORATORIO DE GASTRONOMÍA.</a></li>
          <li><a href="assets/normatividad/reglamentos/7-LABORATORIO-DE-AA.pdf" target="_blank" download>7.- REGLAMENTO DEL LABORATORIO DE ANÁLISIS DE ALIMENTOS.</a></li>
          
          
        </ul>
      </div>

      <!-- IMSS -->
      <div class="tab-pane fade" id="imss" role="tabpanel">
        <h5>IMSS</h5>
        <ul class="pdf-list">
          <li><a href="http://www.diputados.gob.mx/LeyesBiblio/regley/Reg_LSS_MACERF.pdf" target="_blank" download>1.- REGLAMENTO DE LA LEY DEL SEGURO SOCIAL EN MATERIA DE AFILIACIÓN, CLASIFICACIÓN DE EMPRESAS, RECAUDACIÓN Y FISCALIZACIÓN</a></li>
        
        </ul>
      </div>

      <!-- TECNM CAMPUS ESCÁRCEGA -->
      <div class="tab-pane fade" id="tecnm" role="tabpanel">
        <h5>TECNM CAMPUS ESCÁRCEGA</h5>
        <ul class="pdf-list">
          <h4> Manual de organizacion </h4>
          <li><a href="assets/normatividad/itse/Manual-de-Organización-2022-dictaminado.pdf " target="_blank" download>MANUAL DE ORGANIZACIÓN 2022</a></li>
          <li><a href="assets/normatividad/itse/Manual-de-Organizacion-2021.pdf " target="_blank" download>MANUAL DE ORGANIZACIÓN 2021</a></li>
          <li><a href="assets/normatividad/itse/MO-2808_VI-2020.pdf " target="_blank" download>MANUAL DE ORGANIZACIÓN 2020</a></li>
          <li><a href="assets/normatividad/itse/MANUAL-DE-ORGANIZACION-2019.pdf" target="_blank" download>MANUAL DE ORGANIZACIÓN 2019</a></li>
          <li><a href="assets/normatividad/itse/Manual-de-Organizacion-2018.pdf" target="_blank" download>MANUAL DE ORGANIZACIÓN 2018</a></li>
          <li><a href="assets/normatividad/itse/MO-2808-1_2017-Oficial.pdf" target="_blank" download>MANUAL DE ORGANIZACIÓN 2017</a></li>
          <h4> Manual de Procedimientos </h4>
          <li><a href="assets/normatividad/itse/Manual-de-Procedimientos-2021.pdf" target="_blank" download>MANUAL DE PROCEDIMIENTOS 2021  </a></li>
          <li><a href="assets/normatividad/itse/MP-2808-2020.pdf" target="_blank" download>MANUAL DE PROCEDIMIENTOS 2020 </a></li>
          <li><a href="assets/normatividad/itse/MANUAL-DE-PROCEDIMIENTOS-2019.pdf" target="_blank" download>MANUAL DE PROCEDIMIENTOS 2019</a></li>
          <h4> Estructura Organica </h4>
           <li><a href="assets/normatividad/itse/Estructura-Organica-2022-dictaminada.pdf" target="_blank" download>ESTRUCTURA 2022</a></li>
          <li><a href="assets/normatividad/itse/Estructura-2021.pdf" target="_blank" download>ESTRUCTURA 2021</a></li>
          <li><a href="assets/normatividad/itse/Estructura-Organica-2020.pdf" target="_blank" download>ESTRUCTURA 2020</a></li>
          <li><a href="assets/normatividad/itse/Estructura-Organizacional-2018.pdf" target="_blank" download>ESTRUCTURA 2018</a></li>
          <li><a href="assets/normatividad/itse/Estructura2017.pdf" target="_blank" download>ESTRUCTURA 2017</a></li>
          <li><a href="assets/normatividad/itse/Estructura2016.pdf" target="_blank" download>ESTRUCTURA 2016</a></li>

        </ul>
      </div>

    </div>
  </div>
</section>